module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-56-min.27203a69.jpg";